import { Switch, Route } from "react-router";

import Box from "@mui/material/Box";

import MemberEditNavigation from "../../features/user-navigation/MemberEditNavigation";
import PropertiesEdit from "../../features/properties-edit";
import UserAircraftManagement from "../../features/user-aircraft-management";
import AircraftSpecialization from "../../features/aircraft-specialization";
import { useCrewMembersNavigation } from "../../hooks/useCrewMembersNavigation";

const MemberEdit = ({ match }) => {
  const { handleGoBack } = useCrewMembersNavigation();

  return (
    <>
      <Box
        sx={{
          marginBottom: "1.5rem",
        }}
      >
        <Route
          path={`${match.path}/:pageId`}
          render={(props) => <MemberEditNavigation {...props} onGoBack={handleGoBack} />}
        />
      </Box>
      <Switch>
        <Route path={`${match.path}/properties`} component={PropertiesEdit} />
        <Route path={`${match.path}/aircraft-and-specialization`} component={AircraftSpecialization} />
        <Route path={`${match.path}/aircraft`} component={UserAircraftManagement} />
      </Switch>
    </>
  );
};

export default MemberEdit;
